"use client";

import { useEffect } from "react";

export function ScrollEffects() {
  useEffect(() => {
    let lastY = window.scrollY;

    const onScroll = () => {
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      if (y > 140 && delta > 2) {
        document.documentElement.style.setProperty("--hdr-y", "-100%");
      } else if (delta < -2 || y < 140) {
        document.documentElement.style.setProperty("--hdr-y", "0px");
      }
      lastY = y;
      document.documentElement.style.setProperty(
        "--par-y",
        `${(y * 0.12).toFixed(1)}px`,
      );
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute("data-in", "1");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
    );

    const arm = () => {
      document
        .querySelectorAll("[data-reveal]:not([data-in])")
        .forEach((el) => {
          el.setAttribute("data-armed", "");
          io.observe(el);
        });
    };
    arm();
    const sweep = window.setInterval(arm, 600);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.clearInterval(sweep);
      io.disconnect();
    };
  }, []);

  return null;
}
